import { render } from "./QhlsList.vue?vue&type=template&id=6b82b81c&scoped=true"
import script from "./QhlsList.vue?vue&type=script&lang=js"
export * from "./QhlsList.vue?vue&type=script&lang=js"

import "./QhlsList.vue?vue&type=style&index=0&id=6b82b81c&scoped=true&lang=css"

import exportComponent from "/Users/habeebrahman/Documents/htdocs/cdz_projects/wg-frontend-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b82b81c"]])

export default __exports__